export default {

    DEV_SKIP_ANIM: false,

    Events: {


        // Global
        appHasLoadedRessources: "appHasLoadedRessources",
        globalResize: "globalResize",

        onLoaderEnd: "onLoaderEnd",
        onSliderSlide: "onSliderSlide",
        stopSceneLogo: "stopSceneLogo",
        restartSceneLogo: "restartSceneLogo",

        // Logo
        logoGoHeader: "logoGoHeader",
        logoGoHeaderMobile: "logoGoHeaderMobile",
        logoGoMiddle: "logoGoMiddle",
        logoGoMiddleMobile: "logoGoMiddleMobile",

        // WorkListDesktop
        exitWorkListDesktop: "exitWorkListDesktop"


    },

    Animations: {
        easeDecrement: "power2.out",
        easeInOut: "power2.inOut",
        
        durationLong: 2,
    },

    LINKS_TYPE: {
        external: "external",
        mail: "mail",
        phone: "phone",
    },

    BREAKPOINTS: {
        Desktop: 992
    },

}